<!-- 专业合作社 -->
<template>
<div class="info-block">
  <router-link class="info-block-a" :to="'/zyhzs/hzsDetail/'+info.id" v-bind:style="{backgroundImage:'url('+info.photosBg+')'}" target="_blank">
    <div class="div-1">
      <div class="div-1-1">{{info.name.length>25?(info.name.substring(0,25)+'...'):info.name}}</div>
      <div class="div-1-2">占地面积：{{info.area}}亩</div>
      <div class="div-1-3">{{info.address}}</div>
      <div class="div-1-4">
        <a class="td-action-1">点击浏览</a>
      </div>
    </div>
    <div class="div-2">{{info.addressInfo.substring(0,40)}}</div>
    <div class="div-3">{{info.introduce.length>80?(info.introduce.substring(0,80)+'...'):info.introduce}}</div>
  </router-link>
</div>
</template>

<script>
export default {
  name: 'ZyhzsInfo1',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:150px;
  padding:0px;
  margin:0px 1px 20px 0px;
  //background-color: #F6F8F9;
  border-bottom:1px solid #707070;
  background-size: 210px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border-bottom:1px solid var(--color6);
  //box-shadow:0px 0px 1px 0px var(--color6);
}

.info-block .info-block-a:hover > .div-1 >.div-1-1 {
  color:var(--color6);
}

.div-1{
  position:relative;
  height:50%;
  width:100%;
  padding:0px 150px 0px 230px;
  //background:red;

}

.div-1-1{
  position:relative;
  height:30px;
  //background:red;
  font-size:14px;
  font-weight:600;
  text-align:left;
  color:#515151;
  padding:2px 10px 10px 0px;
}

.div-1-2{
  position:relative;
  height:20px;
  //background:red;
  font-size:12px;
  text-align:left;
  font-weight:500;
  color:#515151;
  padding:0px 10px 5px 0px;
}

.div-1-3{
  position:relative;
  height:20px;
  //background:red;
  font-size:12px;
  text-align:left;
  font-weight:500;
  color:var(--color6);
  padding:0px 10px 5px 0px;
}

.div-1-4{
  position:absolute;
  top:0px;
  right:0px;
  width:150px;
  margin:0px;
  padding-left:10px;
  //background:yellow;
}

.div-1-4 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 15px 5px 15px;
  margin-top:10px;
  border:1px solid var(--color1);
  font-size:12px;
  color:#515151;
  line-height:20px;
  text-align:center;
}

.td-action-1:hover{
  border:1px solid var(--color1);
  background:var(--color1);
  color:#fff;
}


.div-2{
  position:relative;
  height:20%;
  width:100%;
  padding:0px 10px 0px 230px;
  color:#515151;
  //background:#fff;
}

.div-3{
  position:relative;
  height:30%;
  width:100%;
  padding:0px 10px 0px 230px;
  color:#8a8a8a;
  //background:#fff;
}


.info-block .cell-base-info{
  position:relative;
  height:70px;
  color:#000;
  background-color:#fff;
  padding-right:0px;
}

.cell-base-info .base-info-title{
  float:left;
  height:30px;
  margin-right:75px;
  font-size:14px;
  font-weight:600;
  line-height:30px;
}

.cell-base-info .base-info-label{
  float:left;
  height:40px;
  margin-right:75px;
  font-size:14px;
  line-height:20px;
}

.cell-base-info .base-info-image{
  position:absolute;
  top:0px;
  right:0px;
  height:70px;
  width:70px;
  color:#000;
  border-radius:10px;
  background-color:#eee;
  padding-right:70px;
  background-size: 70px auto;
  background-repeat: no-repeat;
  background-position: right top;
}

.list-container-cell .cell-col-info{
  height:70px;
  padding-top:10px;
  background-color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/module/ZyhzsInfo1.vue